import axios from 'axios';

const mingoliInstance = axios.create({
  baseURL: 'https://dev.staticcomputersinc.com/mingoli',
  timeout: 30000,
});

export default mingoliInstance;